import styled from "styled-components";

import { Dialog } from "../Dialog";

export const HiddenElements = styled(Dialog.Dialog)`
  flex-basis: 30px;
  background-color: var(--section-snow-background-color,var(--snow));
  width: 224px;
  max-height: 201px;
  display: inline-block !important;
  var(--section-granite-shadow-box-shadow-color,var(--granite-shadow));
  border-radius: 2px;
  display: none;
  margin-top: 4px;
  padding: 8px 0 8px 16px;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 4px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background-color: var(--section-granite-background-color,var(--granite));
  }
`;
export default HiddenElements;
